const { getBootstrapData } = require('@swa-ui/bootstrap');
const { window } = require('@swa-ui/browser/window');
const { logger } = require('@swa-ui/log');

const environmentTierTypes = [
  { hostMatches: /^((www|espanol|mobile|mobile-offline)\.(southwest|swabiz)|southwestwifi)\.com$/, id: 'prod' },
  { hostMatches: /^(espanol-)?(southwest|swabiz|mobile)\.cstg(\d+)\.qa\.southwest\.com$/, id: 'cstg' },
  { hostMatches: /^cstg(\d+)\.qa\.southwestwifi\.com$/, id: 'cstg' },
  { hostMatches: /^(espanol-)?(southwest|swabiz|mobile)\.efix(\d+)\.qa\.southwest\.com$/, id: 'efix' },
  { hostMatches: /^efix(\d+)\.qa\.southwestwifi\.com$/, id: 'efix' },
  { hostMatches: /^(espanol-)?(southwest|swabiz|mobile)\.qa(\d+)\.southwest\.com$/, id: 'qa' },
  { hostMatches: /^qa(\d+)\.southwestwifi\.com$/, id: 'qa' },
  { hostMatches: /^(espanol-)?(southwest|swabiz|mobile)\.ptest(\d+)\.qa\.southwest\.com$/, id: 'ptest' },
  { hostMatches: /^ptest(\d+)\.qa\.southwestwifi\.com$/, id: 'ptest' },
  { hostMatches: /^(espanol-)?(southwest|swabiz|mobile)\.dev(\d+)\.southwest\.com$/, id: 'dev' },
  { hostMatches: /^dev(\d+)\.southwestwifi\.com$/, id: 'dev' },
  { hostMatches: /.*/, id: 'local' },
];

const getEnvironmentTier = () => {
  const { hostname } = window?.location ?? { hostname: 'www.southwest.com' };
  const match = environmentTierTypes.find((tier) => tier.hostMatches.test(hostname));

  return match.id;
};

const configureNextGenLogger = () => {
  const environmentTier = getEnvironmentTier();
  const apiKey = getBootstrapData('api-keys')?.[environmentTier];

  logger.init({ apiKey, appId: 'corporate-landing-home-page', channelId: 'swabiz' });
};

module.exports = { configureNextGenLogger, getEnvironmentTier };
